// extracted by mini-css-extract-plugin
module.exports = {"cWhite":"#FFFFFF","NewLifeTime":"NewLifeTime_NewLifeTime__omXWw"};